import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  fragment ProductVariantFields on ProductVariant {\n    id\n    sku\n    name\n    translation(languageCode: $languageCode) {\n      name\n    }\n    quantityAvailable(countryCode: $countryCode)\n    isAvailable\n    pricing {\n      onSale\n      priceUndiscounted {\n        ...Price\n      }\n      price {\n        ...Price\n      }\n    }\n    attributes {\n      attribute {\n        id\n        name\n        translation(languageCode: $languageCode) {\n          name\n        }\n      }\n      values {\n        id\n        name\n        translation(languageCode: $languageCode) {\n          name\n        }\n        value: name\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fragment SelectedAttributeFields on SelectedAttribute {\n    attribute {\n      id\n      name\n      translation(languageCode: $languageCode) {\n        name\n      }\n    }\n    values {\n      id\n      name\n      translation(languageCode: $languageCode) {\n        name\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment BasicProductFields on Product {\n    id\n    name\n    translation(languageCode: $languageCode) {\n      name\n    }\n    slug\n    thumbnail {\n      url\n      alt\n    }\n    thumbnail2x: thumbnail(size: 510) {\n      url\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
import { checkoutPriceFragment } from "./checkout";
export var basicProductFragment = gql(_templateObject());
export var selectedAttributeFragment = gql(_templateObject2());
export var productVariantFragment = gql(_templateObject3(), checkoutPriceFragment);